import React from "react";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import { usePopUpsV2 } from "components/PopUpManagerV2/hooks/usePopUpsV2";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import type { SwiperOptions } from "swiper/types";
import { useMediaQuery } from "@mui/material";

import {
	Container,
	CustomButton,
	DataContainer,
	Header,
	InfoCard,
	InfoCardImage,
	InfoCardText,
	SwiperContainer,
	Title
} from "./styles";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useImagePath } from "hooks/useImagePath";
import { friendCenterAssets } from "assets/cdn";

interface Props {}

const steps = [
	{
		image: friendCenterAssets.friendShop.steps.step1,
		text: "Select a gift to send to a Friend"
	},
	{
		image: friendCenterAssets.friendShop.steps.step2,
		text: "Pick the FRIEND that will receive it."
	},
	{
		image: friendCenterAssets.friendShop.steps.step3,
		text: "Purchase the GIFT and claim your REWARD!"
	}
];

const inviteSteps = [
	{
		image: friendCenterAssets.friendInvite.steps.step1,
		text: "Tap Invite to send your friends an invitation to the web!"
	},
	{
		image: friendCenterAssets.friendInvite.steps.step2,
		text: "Collect Rewards for every friend who joins!"
	},
	{
		image: friendCenterAssets.friendInvite.steps.step3,
		text: "Claim the top Reward!  The meter will restart once it's completed!"
	}
];

export const FriendShopInfoPopup: React.FC<Props> = () => {
	const { getImage } = useImagePath("cdn");
	const { close, stack } = usePopUpsV2();
	const isPortrait = useMediaQuery("(orientation: portrait)");
	const scale = useCalculateScale(
		isPortrait ? 343 + 40 : 910 + 40,
		isPortrait ? 445 + 40 : 410 + 40
	);
	const swiperParams: SwiperOptions = {
		modules: [Pagination],
		rewind: true,
		slidesPerView: isPortrait ? 1.2 : 3
		//spaceBetween: 14
	};
	const isFriendInvite = stack?.[0]?.id !== "friend-shop-info-popup";
	const infoCardClassName = isFriendInvite ? "isFriendInvite" : "";
	const backgroundImage = getImage(
		isPortrait
			? friendCenterAssets.common.confirmPopupBackground
			: isFriendInvite
			? friendCenterAssets.friendInvite.popupBackgroundLandscape
			: friendCenterAssets.friendShop.infoPopupBackgroundLandscape
	);

	const onClose = () => {
		close({ variant: "friend-shop-info-popup" });
	};

	return (
		<Container scale={scale}>
			<Header $backgroundImage={backgroundImage}>
				<Title>
					{stack?.[0]?.id === "friend-shop-info-popup" ? (
						<span>WEB GIFT TO A{isPortrait && <br />} FRIEND!</span>
					) : (
						<span>
							INVITE FRIENDS
							{isPortrait && <br />} TO WEB!
						</span>
					)}
				</Title>
			</Header>
			<CloseIconButton onClose={onClose} />
			<DataContainer>
				<SwiperContainer>
					<Swiper {...swiperParams}>
						{(stack?.[0]?.id === "friend-shop-info-popup"
							? steps
							: inviteSteps
						).map((step, index) => (
							<SwiperSlide key={index} style={{ height: "15.56em" }}>
								<InfoCard className={infoCardClassName}>
									<InfoCardImage
										src={getImage(step.image)}
										alt={step.text}
										className={infoCardClassName}
									/>
									<InfoCardText>{step.text}</InfoCardText>
								</InfoCard>
							</SwiperSlide>
						))}
					</Swiper>
				</SwiperContainer>
				<CustomButton
					variant="contained"
					color="success"
					themeColor="secondary"
					size="large"
					onClick={onClose}
				>
					Okay
				</CustomButton>
			</DataContainer>
		</Container>
	);
};
